<div style="gap: 8px !important;">
    <div style="display: flex; justify-content: space-between; padding-bottom: 8px;">
    <div style="font-size: 16px; font-weight: 700; padding: 0px 10px 0px 10px;">{{'digital_certificate_management.title_sign' | translate}}</div>
    <h2 mat-dialog-title mat-dialog-draggable-title style="right: 0; margin-bottom: 0px !important; display: flow-root;">
        <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
          <span aria-hidden="true">&times;</span>
        </button>
    </h2>
    </div>
    <div class="title_hin" style="padding-bottom: 8px; font-size: 14px; font-weight: 400; background: #EE00331A;line-height: 20px; font-style: italic; padding: 10px;
    border-radius: 12px;">
        <strong>{{'admin_branch_management.note' | translate}}:</strong>
        {{'digital_certificate_management.time_active' | translate}}
    </div>
    <mat-dialog-content style="height: 260px !important; overflow: hidden;">
        <div class="pb-3 pt-2">
            <!-- <ng-container>
                <div class="text-center">
                    <span>{{
                        "digital_certificate_management.not_exist_certificate"
                        | translate
                        }}</span>
                    <span *ngIf="!isHasPermissionAddCert">,
                        {{
                        "digital_certificate_management.please_contact_admin"
                        | translate
                        }}</span>
                    <span *ngIf="isHasPermissionAddCert">,
                        {{
                        "digital_certificate_management.please_select_add_cert"
                        | translate
                        }}</span>
                </div>
            </ng-container> -->

                <div class="mb-2 pb-25">
                    <div class="title_hin" style="font-size: 14px; font-weight: 400; padding: 0px 10px 15px 10px;">
                        {{'digital_certificate_management.select_sign' | translate}}
                    </div>
                    <mat-radio-group [(ngModel)]="typeCertificate"
                        [ngModelOptions]="{ standalone: true }" class="mb-3 flex radio-group" style="padding-left: 20px ;">
                        <!-- <mat-radio-button 
                            [value]="enumSignMethod.SIGN_SERVER"
                            class="pr-3">
                            {{'digital_certificate_management.cbx_certificate_type.cbx_hsm' | translate}}</mat-radio-button>
                        <mat-radio-button 
                            [value]="enumSignMethod.SIGN_USB_TOKEN"
                            class="pr-3">
                            {{'digital_certificate_management.cbx_certificate_type.cbx_usb' | translate}}</mat-radio-button>
                        <mat-radio-button 
                            [value]="enumSignMethod.SIGN_SIM_CA"
                            class="pr-3">
                            {{'digital_certificate_management.cbx_certificate_type.cbx_sim_ca' | translate}}</mat-radio-button> -->
                        <mat-radio-button 
                            [value]="enumSignMethod.CLOUD_CA"
                            class="pr-3">
                            {{'digital_certificate_management.cbx_certificate_type.cbx_cloud_ca' | translate}}
                        </mat-radio-button>
                        <!-- <mat-radio-button
                            [value]="enumSignMethod.SIGN_OTP"
                            class="pr-3">
                            {{'digital_certificate_management.cbx_certificate_type.cbx_otp_2' | translate}} {{ supportEkyc ? ( "digital_certificate_management.rd_certificate_type.ekyc_support" | translate) : '' }}
                        </mat-radio-button>
                        <mat-radio-button
                            [value]="enumSignMethod.EASY_CA"
                            class="pr-3">
                            {{'digital_certificate_management.cbx_certificate_type.cbx_easy_ca' | translate}}
                        </mat-radio-button> -->
                    </mat-radio-group>
                </div>

                <!-- <div class="title_hin" *ngIf="!this.imageCertificates.length > 0 " style=" font-size: 24px;
                font-weight: 400;
                padding: 0px 10px 15px 10px;
                display: flex;
                justify-content: center;
                padding-bottom: 123px;">
                    {{'digital_certificate_management.empty_sign' | translate}}
                </div> -->
                <ng-container *ngFor="let item of imageCertificates">
                    <mat-radio-group aria-labelledby="example-radio-group-label"
                        class="example-radio-group mt-2" [ngModel]="selectedCert"
                        (ngModelChange)="selectCertificate($event)"
                        [ngModelOptions]="{ standalone: true }">
                        <div class="mat-table-sign-document mat-table-sign-flow-document ">
                            <ng-container>
                            <!--cloud ca-->
                            <mat-table [dataSource]="item.listCert || []"
                                style="border: 1px solid #c8c8c8 !important; max-height: 158px; overflow: auto;"
                               >
                                <!-- Radio Button -->
                                <!-- <ng-container matColumnDef="radioBtn">
                                    <mat-header-cell *matHeaderCellDef
                                        class="co-col mat-cell-non-boder-right-bottom"
                                        style="width: 10%; max-width: 10%;">
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-right-bottom align-middle word-break-line responsive-radio"
                                        style="width: 10%; max-width: 10%;"
                                        matTooltip="{{ cert.issuedTo }}">
                                        <div class="pre-wrap">
                                            <mat-radio-button
                                                class="ml-2 mt-2 mat-header-cell-center"
                                                [value]="cert">
                                            </mat-radio-button>
                                        </div>
                                    </mat-cell>
                                </ng-container> -->
                                <!-- Chủ thể CTS column -->
                                <ng-container matColumnDef="issuedTo">
                                    <mat-header-cell *matHeaderCellDef
                                        class="co-col mat-cell-non-boder-right-bottom"
                                        style="width: 40%">
                                        {{
                                        "digital_certificate_management.issuedTo_name" | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let cert; let i = index"
                                        class="mat-cell-non-boder-right-bottom align-middle word-break-line responsive-radio"
                                        style="width: 40%;"
                                        matTooltip="{{ cert.issuedTo }}">
                                        <div class="pre-wrap" style="display: flex !important; align-items: center !important; padding-left: 20px;">
                                            <mat-radio-button
                                                class="ml-2 mt-2 mat-header-cell-center"
                                                [value]="cert"
                                                [checked]="i === 0">
                                            </mat-radio-button>
                                            <span
                                                class="pre-wrap">{{cert.issuedTo}}</span>
                                        </div>
                                    </mat-cell>
                                </ng-container>

                                <!-- MST/CCCD/Tai khoan/SDT column -->
                                <ng-container matColumnDef="mstCccdTkSdt">
                                    <mat-header-cell *matHeaderCellDef
                                        class="co-col mat-cell-non-boder-right-bottom"
                                        style="max-width: 30%">
                                        {{
                                        "digital_certificate_management.mst_cccd_tk_sdt"
                                        | translate }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-right-bottom word-break-line"
                                        style="max-width: 30%"
                                        matTooltip="{{ cert.cloudCaUserId }}">
                                        {{ cert.cloudCaUserId }}
                                    </mat-cell>
                                </ng-container>

                                <!-- Ngày hết hiệu lực -->
                                <ng-container matColumnDef="expireDate">
                                    <mat-header-cell *matHeaderCellDef
                                        class="co-col mat-cell-non-boder-right-bottom"
                                        style="max-width: 20%">
                                        {{"headertable.end_of_activate_date" |
                                        translate}}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-right-bottom number-cell-center word-break-line"
                                        style="max-width: 20%"
                                        matTooltip="{{ cert.expireDate | dateformat }}">
                                        {{ cert.expireDate | dateformat }}
                                    </mat-cell>
                                </ng-container>

                                <!-- Lưu phiên ký -->
                                <!-- <ng-container matColumnDef="hasTransSaved">
                                    <mat-header-cell *matHeaderCellDef style="max-width: 10%;" style="width: 10%"
                                      class="co-col mat-cell-non-boder-bottom">
                                      {{'enterprise_group_user_management.table_headers.save_session_sign' | translate}}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let cert" style="max-width: 10%;" style="width: 10%"
                                      class="mat-cell-non-boder-bottom number-cell-center word-break-line">
                                      <div *ngIf="cert.hasTransSaved == true" [matTooltip]="'button.yes_sign_method_default' | translate" style="color: #09847b">
                                        {{ 'button.yes_sign_method_default' | translate }}
                                      </div>
                                      <div *ngIf="cert.hasTransSaved == false" [matTooltip]="'button.no' | translate" style="color: #da190b">
                                        {{ 'button.no' | translate }}
                                      </div>
                                    </mat-cell>
                                </ng-container> -->

                                <mat-header-row *matHeaderRowDef="columnsToDisplayCloudCA">
                                </mat-header-row>
                                <mat-row
                                    *matRowDef="let row; columns: columnsToDisplayCloudCA">
                                </mat-row>

                                <!-- <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell" [colSpan]="columnsToDisplayCloudCA.length" 
                                        style="text-align: center; padding: 16px;">
                                      Không có dữ liệu
                                    </td>
                                  </tr> -->
                            </mat-table>

                            <div *ngIf="!item.listCert || item.listCert.length === 0"
                         style="text-align: center; padding: 16px; border: 1px solid #c8c8c8;">
                             Không có dữ liệu
                            </div>
                            </ng-container>
                            
        
                         </div>   
                         
                    </mat-radio-group>
                </ng-container>

        </div>
    </mat-dialog-content>

 <!-- Button show mobile -->
 <div class="scontract-btn-mobile bg-white d-flex justify-content-center rounded"
     style="background: white;">
     <div style="display: flex; justify-content: center;">
         <button style="min-width: 90px !important;" id="btn-cancel" mat-stroked-button color="primary" class="mr-2"
         type="button" (click)="onNoClick()">
         <mat-icon class="mr-0">cancel</mat-icon>
         {{ "button.cancel" | translate }}
     </button>
     <button style="min-width: 90px !important;" mat-raised-button color="primary" class="mr-2"
         (click)="onClickSignButton()" [disabled]="!selectedCert">
         <!-- <mat-icon class="mr-0">gesture</mat-icon> -->
         <span>{{ "enterprise_contract.buttons.sign" | translate
             }}</span>
         
     </button>
     </div>
 </div>
</div>